// lib
import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// src
import { currentLocalizer } from "i18n/localizer";

const WeekHeader = ({ date }) => {
  const { language } = useSelector((state) => state.ux);
  const localizer = currentLocalizer(language);
  return (
    <div className="cal-week-header">
      <span className="cal-weekday">{localizer.format(date, "ddd ")}</span>
      <span className="cal-day">{localizer.format(date, "D")}</span>
    </div>
  );
};

WeekHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

export default WeekHeader;
